<template>
  <nav class="tabbar">
    <router-link
      :class="{'tabbar__button--active': homeActive}"
      class="tabbar__button"
      :to="{ name: routes.HOME }"
    >
      <div class="tabbar__button-inner" @click="handleButtonInnerClick">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          style="enable-background:new 0 0 24 24;"
          xml:space="preserve"
        >
          <path
            d="M16,22h6.1c0.5,0,0.9-0.4,0.9-0.9V9.3c0-0.4-0.2-0.8-0.6-1.1L12.3,2.1c-0.2-0.1-0.4-0.1-0.6,0L1.6,8.2C1.2,8.5,1,8.9,1,9.3
          v11.8C1,21.6,1.4,22,1.9,22H8c0.5,0,1-0.4,1-1v-6.6c0-0.8,0.6-1.4,1.4-1.4h3.1c0.8,0,1.5,0.7,1.5,1.5V21C15,21.5,15.5,22,16,22z"
          ></path>
          <path d="M16,3h4v2.9l-4-2.5V3z"></path>
        </svg>
        <span>Hjem</span>
      </div>
    </router-link>
    <router-link
      :class="{'tabbar__button--active': bookingActive }"
      class="tabbar__button"
      :to="{ name: routes.BOOKING }"
    >
      <div class="tabbar__button-inner" @click="handleButtonInnerClick">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          style="enable-background:new 0 0 24 24;"
          xml:space="preserve"
        >
          <path
            d="M22.5,3.2c-0.2-0.2-0.5-0.4-0.8-0.4c-0.6-0.1-2.1,0.9-3,1.4c-1.3,0.8-3.2,2.1-5.1,4l-4.1,4.1c-0.5,0.5-0.5,1.4,0,1.9l0,0
          L3.7,20c-0.5,0.5-0.5,1.4,0,1.9c0.5,0.5,1.4,0.5,1.9,0L22.5,5.1c0.4-0.4,0.5-0.9,0.3-1.4C22.7,3.5,22.6,3.4,22.5,3.2L22.5,3.2z"
          ></path>
          <path d="M15,14l-1.9,1.9l5.9,5.9c0.5,0.5,1.4,0.5,1.9,0c0.5-0.5,0.5-1.4,0-1.9L15,14z"></path>
          <path
            d="M7.4,10.1l1.5,1.5l1.9-1.9L9.3,8.3c0.3-0.9,0-1.9-0.7-2.6c0,0,0,0,0,0c0,0,0,0,0,0L4.5,1.5C4.3,1.3,4,1.3,3.8,1.5
            C3.7,1.7,3.7,2,3.8,2.1L7.7,6l0,0c0,0,0,0,0,0c0.1,0.1,0.1,0.3,0,0.4c-0.1,0.1-0.3,0.1-0.4,0c0,0,0,0,0,0l0,0L3.5,2.5
            C3.3,2.3,3,2.3,2.8,2.5C2.7,2.7,2.7,3,2.8,3.2L6.7,7l0,0c0,0,0,0,0,0c0.1,0.1,0.1,0.3,0,0.4c-0.1,0.1-0.3,0.1-0.4,0c0,0,0,0,0,0
            l0,0L2.4,3.5C2.3,3.4,2,3.4,1.8,3.5C1.6,3.7,1.6,4,1.8,4.2L5.6,8c0,0,0,0,0,0c0.1,0.1,0.1,0.3,0,0.4c-0.1,0.1-0.3,0.1-0.4,0
            c0,0,0,0,0,0l0,0L1.4,4.6C1.2,4.4,1,4.4,0.8,4.6C0.6,4.7,0.6,5,0.8,5.2l4.1,4.1c0,0,0,0,0,0c0,0,0,0,0,0C5.6,10,6.5,10.3,7.4,10.1z"
          ></path>
          <path
            d="M20.7,19.7l-5.4-5.4l-1.9,1.9l5.4,5.4c0.5,0.5,1.4,0.5,1.9,0C21.2,21,21.2,20.2,20.7,19.7z"
          ></path>
        </svg>
        <span>Bordbestilling</span>
      </div>
    </router-link>
    <a class="tabbar__button" href="https://www.halifax.dk/takeaway" target="_blank">
      <div class="tabbar__button-inner" @click="handleButtonInnerClick">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          style="enable-background:new 0 0 24 24;"
          xml:space="preserve"
        >
          <path
            d="M8.4,6.8c-0.3,0-0.6-0.1-0.6-0.2c0-0.1,0.3-0.2,0.6-0.2S9,6.4,9,6.5C9,6.6,8.7,6.8,8.4,6.8z M23,17.8L23,17.8z M22.6,17.6
          H1.4c-0.2,0-0.3,0-0.4,0.2l0,0c-0.1,0.1-0.2,0.3-0.2,0.4v1.9c0,0.7,0.3,1.3,0.7,1.7l0,0c0.5,0.4,1.1,0.7,1.8,0.7h17.4
          c0.7,0,1.3-0.3,1.8-0.7c0.4-0.5,0.7-1.1,0.7-1.8v-1.9c0-0.2-0.1-0.3-0.2-0.4C22.9,17.7,22.8,17.6,22.6,17.6z M14.1,16.3l-2.3-1.9
          H0.9c-0.2,0-0.5,0.1-0.6,0.3l0,0C0.1,14.9,0,15.1,0,15.4c0,0.3,0.1,0.5,0.3,0.6c0.2,0.2,0.4,0.3,0.6,0.3H14.1L14.1,16.3z M18.4,14.4
          l-1.2,1.9h5.9c0.2,0,0.5-0.1,0.6-0.3c0.2-0.1,0.3-0.4,0.3-0.6c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.1-0.4-0.3-0.6-0.3L18.4,14.4L18.4,14.4z
          M16.8,14.4h-3l1.9,1.6L16.8,14.4z M12,11.3H1.7H0.9c-0.2,0-0.5,0.1-0.6,0.3C0.1,11.7,0,12,0,12.2s0.1,0.5,0.3,0.6
          c0.2,0.1,0.4,0.3,0.6,0.3H12h6h0.1h4.9c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6s-0.1-0.5-0.2-0.6l0,0
          c-0.2-0.2-0.4-0.3-0.6-0.3h-0.8C22.3,11.3,12,11.3,12,11.3z M12,1.4c-2.9,0-6,0.8-8.2,2.4C2,5,0.8,6.8,0.8,9c0,0.2,0.1,0.5,0.3,0.6
          l0,0C1.2,9.9,1.5,10,1.7,10h20.6c0.2,0,0.5-0.1,0.6-0.3c0.1-0.2,0.3-0.4,0.3-0.6c0-2.3-1.2-4.1-3-5.3C18,2.2,14.9,1.4,12,1.4L12,1.4
          z M9.7,8.1c0-0.1,0.2-0.2,0.6-0.2c0.3,0,0.6,0.1,0.6,0.2s-0.3,0.2-0.6,0.2C10,8.4,9.7,8.3,9.7,8.1z M10.8,4.9c0,0.1-0.3,0.2-0.6,0.2
          S9.6,5,9.6,4.9c0-0.1,0.3-0.3,0.6-0.3S10.8,4.8,10.8,4.9z M9.7,3.2c0,0.1-0.3,0.3-0.6,0.3S8.5,3.3,8.5,3.2s0.3-0.2,0.6-0.2
          S9.7,3,9.7,3.2z M12,3.8c-0.3,0-0.6-0.1-0.6-0.3s0.3-0.2,0.6-0.2c0.3,0,0.6,0.1,0.6,0.2C12.6,3.7,12.3,3.8,12,3.8z M7.4,8.1
          c0,0.1-0.3,0.2-0.6,0.2S6.2,8.2,6.2,8.1s0.3-0.2,0.6-0.2S7.4,8,7.4,8.1z M3.5,7.9c0.3,0,0.6,0.1,0.6,0.2S3.8,8.4,3.5,8.4
          S2.9,8.2,2.9,8.1S3.2,7.9,3.5,7.9z M13.7,8.4c-0.3,0-0.6-0.1-0.6-0.2c0-0.1,0.3-0.2,0.6-0.2c0.3,0,0.6,0.1,0.6,0.2
          C14.3,8.3,14,8.4,13.7,8.4z M16.6,8.1c0-0.1,0.3-0.2,0.6-0.2s0.6,0.1,0.6,0.2c0,0.1-0.3,0.2-0.6,0.2S16.6,8.3,16.6,8.1z M19.9,8.1
          c0-0.1,0.2-0.2,0.6-0.2s0.6,0.1,0.6,0.2c0,0.1-0.3,0.2-0.6,0.2C20.2,8.4,19.9,8.3,19.9,8.1z M14.9,3.4c-0.3,0-0.6-0.1-0.6-0.3
          s0.3-0.2,0.6-0.2s0.6,0.1,0.6,0.2C15.5,3.3,15.2,3.4,14.9,3.4z M12,6.5c-0.3,0-0.6-0.1-0.6-0.2C11.4,6.1,11.7,6,12,6
          c0.3,0,0.6,0.1,0.6,0.3C12.6,6.4,12.3,6.5,12,6.5z M13.2,4.9c0-0.1,0.3-0.3,0.6-0.3s0.6,0.1,0.6,0.3s-0.2,0.2-0.6,0.2
          S13.2,5.1,13.2,4.9z M15,6.5c0-0.1,0.3-0.2,0.6-0.2s0.6,0.1,0.6,0.2c0,0.1-0.3,0.2-0.6,0.2C15.3,6.8,15,6.6,15,6.5z M18.6,6.3
          c0-0.1,0.3-0.2,0.6-0.2s0.6,0.1,0.6,0.2c0,0.1-0.3,0.3-0.6,0.3C18.9,6.6,18.6,6.5,18.6,6.3L18.6,6.3z M16.7,4.9
          c0-0.1,0.2-0.3,0.6-0.3s0.6,0.1,0.6,0.3s-0.3,0.2-0.6,0.2C17,5.2,16.7,5.1,16.7,4.9z M4.8,6.1c0.3,0,0.6,0.1,0.6,0.2
          c0,0.1-0.2,0.3-0.6,0.3S4.2,6.5,4.2,6.3C4.2,6.2,4.4,6.1,4.8,6.1z M7.2,4.9c0,0.1-0.3,0.2-0.6,0.2S6,5,6,4.9c0-0.1,0.3-0.3,0.6-0.3
          S7.2,4.8,7.2,4.9z"
          ></path>
        </svg>
        <span>Takeaway</span>
      </div>
    </a>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
import routes from '@/router/routes'
import animateProperty from '@/utils/animateProperty'

export default {
  data() {
    return {
      routes
    }
  },
  computed: {
    ...mapState('routing', {
      activeTabbarRoute: 'active_tabbar_route'
    }),
    homeActive() {
      return this.activeTabbarRoute === routes.HOME
    },
    bookingActive() {
      return this.activeTabbarRoute === routes.BOOKING
    }
  },
  methods: {
    async handleButtonInnerClick(event) {
      const link = event.currentTarget.parentElement

      if (link.target === '_blank') {
        event.preventDefault()

        const didConfirm = await this.$store.dispatch('dialog/CONFIRM', {
          props: {
            heading: 'Du er ved at forlade appen',
            body:
              'Vi arbejder stadig på at implementere takeaway i appen. Indtil videre vil du blive sendt videre til vores website, hvorfra du kan bestille din takeaway.'
          }
        })
        if (didConfirm) {
          link.click()
        }
        return
      }
      // If clicked button is active, scroll to top on first click if we are not at the top
      if (link.classList.contains('tabbar__button--active') && window.scrollY > 0) {
        const scrollingElement = window.document.scrollingElement || window.document.documentElement
        animateProperty(scrollingElement, 'scrollTop', 0)
        event.preventDefault()
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/scss/variables';

.tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: $background-color-tabbar;
  z-index: $z-index-tabbar;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: $height-tabbar;
  box-sizing: content-box;
  transform: translate3d(0, 0, 0);

  @include supports-safe-area-insets {
    padding-bottom: var(--safe-area-inset-bottom);
  }
  // Hide if framed
  .window--framed & {
    display: none;
  }
  > * {
    box-sizing: border-box;
  }
  &__button {
    height: $height-tabbar;
    background-color: transparent;
    display: block;
    text-decoration: none;
    color: $background-light-50;
    min-width: 25%;
    font-weight: 600;

    &--active {
      color: $halifax-orange;
    }
    svg {
      width: 24px;
      height: 24px;
      margin-bottom: 4px;
      display: block;
    }
    path,
    rect {
      fill: currentColor;
    }
    span {
      display: block;
      text-align: center;
      font-size: 1rem;
      height: 1em;
      line-height: 1;
    }
  }
  &__button-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
}
</style>
